import { render, staticRenderFns } from "./RequisitionForm.vue?vue&type=template&id=b953b4c6"
import script from "./RequisitionForm.vue?vue&type=script&lang=js"
export * from "./RequisitionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports